import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');
  const location = useLocation();

  useEffect(() => {
    // Check if current route is an admin route
    const isAdminRoute = location.pathname.startsWith('/admin') || location.pathname.startsWith('/imcloginforadmin');

    // Force light theme on admin pages, otherwise use user preference
    const effectiveTheme = isAdminRoute ? 'light' : theme;

    // Apply theme using class instead of data attribute to match CSS
    if (effectiveTheme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }

    // Only save theme preference if not on admin route
    if (!isAdminRoute) {
      localStorage.setItem('theme', theme);
    }
  }, [theme, location.pathname]);

  const toggleTheme = () => {
    setTheme(prevTheme => prevTheme === 'light' ? 'dark' : 'light');
  };

  const value = {
    theme,
    toggleTheme,
    isDark: theme === 'dark'
  };

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};
